"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckPointsNumberInWindowArea = exports.MIN_AREA_POINTS = void 0;
const ml_spectra_processing_1 = require("ml-spectra-processing");
const ChartContext_1 = require("../context/ChartContext");
const useSpectrum_1 = __importDefault(require("./useSpectrum"));
exports.MIN_AREA_POINTS = 5;
function useCheckPointsNumberInWindowArea() {
    const state = (0, ChartContext_1.useChartData)();
    const spectrum = (0, useSpectrum_1.default)(null);
    const { xDomain: [from, to], } = state;
    if (spectrum) {
        const { fromIndex, toIndex } = (0, ml_spectra_processing_1.xGetFromToIndex)(spectrum.data.x, {
            from,
            to,
        });
        return toIndex - fromIndex;
    }
    return 0;
}
exports.useCheckPointsNumberInWindowArea = useCheckPointsNumberInWindowArea;
